import {
    ai_tools_members, ai_tools
  } from "../../js/path";
  import _ from "lodash";
  
  export default {
    data() {
      return {
        showTransactionModal: false,
        transactionList: [],
        editedRowId: null,
        existingTokens: 0,
        addTokens: 0,
        member_tagging : null,
        memberList: [],
        aiServiceList: [],
        pageNo: null,
        status: false,
        ai_services: [],
        commuinityStatus: false,
        posts_id: this.$route.params.id,
        table_header: [],
        fields: [{
            key: "id",
            sortable: true,
          },
          {
            key: "ai_tool_title",
            label: 'AI Tool Title'
          },
          {
            key: "previous_balance",
            label: 'previous balance'
          },
          {
            key: "balance",
            label: 'Balance'
          },
          {
            key: "coins",
            label: 'Coins'
          },
          {
            key: "type",
            label: 'Type'
          },
        ],
        params: "",
        tableData: [],
        activeTab: "all",
        key: 0,
        currentPage: 1,
        filter: null,
        filterOn: [],
        sortBy: "id",
        sortDesc: true,
      };
    },
    methods: {
      capitalize(text) {
        if (!text) return '';
        return text.charAt(0).toUpperCase() + text.slice(1);
      },
      enableTokenEdit(item) {
        this.editedRowId = item.id;
        this.existingTokens = item.tokens ?? 0;
        this.addTokens = 0;
      },
      searchFor() {
        if (this.filter.length > 1) this.fetchData(this.activeTab);
        else if (this.filter.length == 0) this.fetchData(this.activeTab);
      },
      filterPage() {
        if (this.pageNo.length > 0) {
          this.params = `&page=${this.pageNo}`;
          this.fetchData(this.activeTab);
          this.currentPage = this.pageNo;
        }
      },
      search(event) {
        if (this.filter.length > 1) {
          if (event.keyCode == 13) {
            this.fetchData(this.activeTab);
          }
        } else if (this.filter.length == 0) this.fetchData(this.activeTab);
      },
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
      async fetchData(txt) {
        let url = null;
        if (txt == "active") {
          this.activeTab = txt;
          if (this.filter != null && this.filter != "") {
            url = ai_tools_members.getAiToolMemberTransactionHistory  + "/" + this.posts_id + "?filter=" + txt + "&search=" + this.filter;
          } else {
            url = ai_tools_members.getAiToolMemberTransactionHistory + "?filter=" + txt;
          }
        } else if (txt == "trash") {
          this.activeTab = txt;
          if (this.filter != null && this.filter != "") {
            url = ai_tools_members.getAiToolMemberTransactionHistory + "?filter=" + txt + "&search=" + this.filter;
          } else {
            url = ai_tools_members.getAiToolMemberTransactionHistory + "?filter=" + txt;
          }
        } else if (txt == "all") {
          this.activeTab = txt;
          if (this.filter != null && this.filter != "") {
            url = ai_tools_members.getAiToolMemberTransactionHistory  + "/" + this.posts_id + "?filter=" + txt + "&search=" + this.filter;
          } else {
            url = ai_tools_members.getAiToolMemberTransactionHistory + "/" + this.posts_id  + "?filter=" + txt;
          }
        }
        url += this.params;
        this.getUrl();
        this.$store.commit("loader/updateStatus", true);
        try {
          const data = await this.getRequest(url);
          if (data.status) {
            const responseData = data.response;
            this.tableData = responseData;
          }
        } catch (err) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: err.data ? err.data.message : "Please try again!",
          });
        }
        this.$store.commit("loader/updateStatus", false);
        this.key += 1;
      },          
      getUrl() {
        var url = new URL(window.location);
        if (this.activeTab == null || this.activeTab == "") {
          this.activeTab = "all";
        }
        (url.searchParams.has('filter') ? url.searchParams.set('filter', this.activeTab) : url.searchParams.append('filter', this.activeTab));
        if (this.filter != null && this.filter != "") {
          (url.searchParams.has('search') ? url.searchParams.set('search', this.filter) : url.searchParams.append('search', this.filter));
        } else {
          url.searchParams.delete('search');
        }
        if (this.currentPage != null && this.currentPage != "") {
          (url.searchParams.has('page') ? url.searchParams.set('page', this.currentPage) : url.searchParams.append('page', this.currentPage));
        } else {
          url.searchParams.set('page', 1);
        }
        url.search = url.searchParams;
        url = url.toString();
        history.pushState({}, null, url);
      },
      // fetchMemberList: _.debounce(async function (query) {
      //   this.$store.commit("loader/updateStatus", false);
      //   this.memberList = [];
      //   if (query != "" && query != null) {
      //     this.$store.commit("loader/updateStatus", true);
      //     const url = members.getMembers;
      //     console.log(url);
          
      //     const data = await this.getRequest(url + "?search=" + query);
      //     if (data.status) {
      //       this.memberList = data.response.data.map((member) => ({
      //         member_id: member.id,
      //         fnameAndLname: `${member.fname} ${member.lname} - ${member.mobile_number}`,
      //       }));
      //     }
      //   }
      //   this.$store.commit("loader/updateStatus", false);
      // }, 1000),
      fetchAiToolsList: _.debounce(async function (query) {
        this.$store.commit("loader/updateStatus", false);
        this.aiServiceList = [];
        if (query != "" && query != null) {
          this.$store.commit("loader/updateStatus", true);
          const url = ai_tools.getAiToolsUrl;
          const data = await this.getRequest(url + "?search=" + query);
          if (data.status) {
            
            this.aiServiceList = data.response.data.map((member) => ({
              id: member.id,
              title: `${member.title}`,
            }));
          }
        }
        this.$store.commit("loader/updateStatus", false);
      }, 1000),
      async submitMemberMapping() {
        
        this.$store.commit("loader/updateStatus", true);
        try {
          let url = ai_tools.postAiMemberService;
          console.log(this.ai_services);
          
          const payload = {
            member_id: this.member_tagging.member_id,
            ai_tool_id: this.ai_services.map(service => service.id),
          };
           const data = await this.postRequest(url, payload); // postRequest must send JSON
      
          if (data.status) {
            this.$store.commit("toast/updateStatus", {
              status: true,
              icon: "success",
              title: data.message,
            });
            this.$router.push("/ai/ai-tools-members");
          }
        } catch (err) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: err.data ? err.data.message : "Please try again!",
          });
          console.log(err);
        }
        this.$store.commit("loader/updateStatus", false);

      },
      async saveTokens(id){
        this.$store.commit("loader/updateStatus", true);
        try {
          let url = `${ai_tools.addAitokensMember}/${id}`;
          const token = this.addTokens;
          
          const payload = {
            tokens: token,
          };
           const data = await this.postRequest(url, payload); // postRequest must send JSON
      
          if (data.status) {
            this.$store.commit("toast/updateStatus", {
              status: true,
              icon: "success",
              title: data.message,
            });
            this.editedRowId = null;
            this.addTokens = 0;
            this.existingTokens = 0
            location.reload();
            // this.$router.push("/ai/ai-tools-members");
          }
        } catch (err) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: err.data ? err.data.message : "Please try again!",
          });
          console.log(err);
        }
        this.$store.commit("loader/updateStatus", false);
      },
      async fetchTooldetails(item) {
        
        const url = ai_tools.getAiMemberService;
        const data = await this.getRequest(url + "/" + item.id);
        if (data.status) {
          this.ai_services = data.response;
          this.member_tagging = {
            member_id: item.id,
            fnameAndLname: item.name
          };
          this.showInput = true; // show the form if not already visible
        }
      },
      async showTransaction(id){
        const url = ai_tools_members.getAiToolMemberTransactionHistory;
        const data = await this.getRequest(url + "/" + id);
        if(data.status){
          this.showTransactionModal = true;
          this.transactionList = data.response.data;
          console.log(this.transactionList);
        }
      }      
    },
    watch: {
      currentPage: {
        handler: function (value) {
          if (typeof value != undefined) {
            this.params = `&page=${value}`;
            this.fetchData(this.activeTab);
            this.pageNo = this.currentPage;
          }
        },
      },
    },
    created() {
      this.posts_id = this.$route.params.id;
      if (this.$route.name == "add-ai-tools" || this.$route.name == "edit-ai-tools") {
        if (this.$route.name == "edit-ai-tools") {
          this.fetchPosts(this.$route.params.id);
        }
      } else {
        this.activeTab = "all";
        if (this.$route.query.filter) {
          this.activeTab = this.$route.query.filter;
        }
        if (this.$route.query.search) {
          this.filter = this.$route.query.search;
        }
        if (this.$route.query.page && this.$route.query.page != 1) {
          this.currentPage = parseInt(this.$route.query.page);
        } else {
          this.fetchData(this.activeTab);
        }
      }
      this.fields.map((item) => {
        this.table_header.push(item.key);
      });
    },
  };